import * as React from 'react';
import * as style from './styles.css';
export var CloseButton = function CloseButton(props) {
  return /*#__PURE__*/React.createElement("button", {
    className: style['close-button'],
    onClick: function onClick() {
      return props.onClick();
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20",
    fill: "#E4E4E4",
    rx: "10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.646 9.646l2.822-2.821a.51.51 0 0 1 .714-.007.505.505 0 0 1-.007.714l-2.821 2.822 2.821 2.821a.51.51 0 0 1 .007.714.505.505 0 0 1-.714-.007l-2.822-2.821-2.821 2.821a.51.51 0 0 1-.714.007.505.505 0 0 1 .007-.714l2.821-2.821-2.821-2.822a.51.51 0 0 1-.007-.714.505.505 0 0 1 .714.007l2.821 2.821z"
  }))));
};